import React, { Component } from 'react';


class Header extends Component {

    constructor(props){
        super(props)
    }
    render() {
        var valuegrade, text;
        if (this.props.gradeLabel){
            text = this.props.gradeLabel;
        } else {
            if(this.props.valuegrade == "1"){
                text = "LOW"
            }
            if(this.props.valuegrade == "2"){
                text = "MODERATE"
            }
            if(this.props.valuegrade == "3"){
                text = "HIGH"
            }
        }
        

        var risktext 
        if(this.props.content.length){
            risktext = this.props.content;
        } else {
            risktext = 'Your risk is '
        }
        return(
            <div>
                <h2  style={{marginBottom:'20px'}}>{risktext}</h2>
                <h1 style={{marginBottom:'5px', marginTop:'5px'}}>{text}</h1>
            </div>
        )
    }
}

export default Header

